import * as types from "../constants/actionConstants";
import * as portalShared from "../portal/shared/metadataConstantsAndUtilities";
import * as TEMPLATE from "../constants/templateConstants";

const initialState = {

};

const defaultExpanderObj = {
    expanderType: "",
    expanderSet: true,
    expandAll: true,
    expander: {}
};

export default function expanderReducer(state = initialState, action) {
    switch (action.type) {
        case types.EXPANDER_PRESET:

            let initialStateObj = portalShared.cloneObj(state);

            let parentName = action.payload.parentName; // Screen name displaying the expanders
            let expanderType = action.payload.expanderName; // Template Type category, group or question
            let templateKeys = action.payload.templateKeys;
            let templateObjs = action.payload.templates;

            // Check for current screen in object, if NOT then add an object for it.  i.e. CategoryReview
            if (!initialStateObj[parentName]) {
                initialStateObj[parentName] = portalShared.cloneObj(defaultExpanderObj);
                initialStateObj[parentName].expanderType = expanderType;
            }

            // If no parent templates
            if (action.payload.parentKey === "" || !action.payload.parentKey) {
                let tempExpander = initialStateObj[parentName].expander;

                for (let i = 0; i < templateKeys.length; i++) {
                    if(!tempExpander[templateKeys[i]]) {
                        tempExpander[templateKeys[i]] = {
                            open: false,
                            template: templateObjs[templateKeys[i]],
                            //conditional statement that determines whether groupExpanderObj property will be added or not
                            ...(initialStateObj[parentName].expander?.[templateKeys[i]]?.groupExpanderObj &&
                                {groupExpanderObj: initialStateObj[parentName].expander[templateKeys[i]].groupExpanderObj})
                        }; // Add Key to expander, default open false
                    }
                }
            }
            else {
                // Must need to add groups to existing expander

                //const categoryExpander = initialStateObj[parentName].expander.find((obj) => obj.template.templateKey === action.payload.parentKey);
                const categoryExpander = initialStateObj[parentName].expander[action.payload.parentKey];

                if (!categoryExpander.groupExpanderObj) {
                    categoryExpander.groupExpanderObj = portalShared.cloneObj(defaultExpanderObj); // Add an expander object to the category expander obj
                    categoryExpander.groupExpanderObj.expanderType = TEMPLATE.TYPE.GROUP;
                }

                let categoryGroupExpanderObj = categoryExpander.groupExpanderObj.expander;

                for (let i = 0; i < templateKeys.length; i++) {
                    categoryGroupExpanderObj[templateKeys[i]] = {open: false, template: templateObjs[templateKeys[i]]}; // Add Key to expander, default to  open false
                }

            }

            return {
                ...initialStateObj,
            };

        case types.EXPANDER_EXPAND_OR_COLLAPSE_SELECTED:

            let clonedStateObj = portalShared.cloneObj(state);

            let currentScreenObj = clonedStateObj[action.payload.parentName];

            // If no parent key level 1 objects are categories or groups only
            let expanderBase = null;
            let expanderObj = null;

            if (action.payload.parentKey === "NewUnsavedCategory") {

                // Group expander on CategoryEditor but category has not yet been saved
                expanderBase = currentScreenObj;
                expanderObj = expanderBase.expander[action.payload.templateKey];
                expanderObj.open = !expanderObj.open; // Toggle open/close

                expanderBase.expandAll = true; // Assume collapse all, unless still some closed

                Object.keys(expanderBase.expander).forEach(function(key) {
                    if (expanderBase.expander[key].open) {
                        expanderBase.expandAll = false; // if any are expanded change button to Collapse All
                    }
                });

            }
            else if (action.payload.parentKey === "") {
                expanderBase = currentScreenObj;
                expanderObj = currentScreenObj.expander;
                expanderObj[action.payload.templateKey].open = !expanderObj[action.payload.templateKey].open; // Toggle open/close

                expanderBase.expandAll = true; // Check later to see if it should be collapse all

                // If closing a category, then close all groups also, however opening a category will NOT open a group
                if (!expanderObj[action.payload.templateKey].open) {
                    if (expanderObj[action.payload.templateKey].hasOwnProperty("groupExpanderObj")) {

                        expanderObj[action.payload.templateKey].groupExpanderObj.expandAll = true;

                        let groupKeys = expanderObj[action.payload.templateKey].template.groupKeys;
                        for (let ii = 0; ii < groupKeys.length; ii++) {
                            expanderObj[action.payload.templateKey].groupExpanderObj.expander[groupKeys[ii]].open = false;
                        }
                    }
                }

                Object.keys(expanderObj).forEach(function(key) {
                    if (expanderObj[key].open) {
                        expanderBase.expandAll = false; // if any are expanded change button to Collapse All
                    }
                });

            } else {
                // Must be a group expander

                expanderBase = currentScreenObj.expander[action.payload.parentKey].groupExpanderObj;
                expanderObj = currentScreenObj.expander[action.payload.parentKey].groupExpanderObj.expander;
                expanderObj[action.payload.templateKey].open = !expanderObj[action.payload.templateKey].open; // Toggle open/close

                expanderBase.expandAll = true; // Assume collapse all, unless still some closed

                Object.keys(expanderObj).forEach(function(key) {
                    if (expanderObj[key].open) {
                        expanderBase.expandAll = false; // if any are expanded change button to Collapse All
                    }
                });
            }

            return {
                ...clonedStateObj,
            };

        case types.EXPANDER_EXPAND_OR_COLLAPSE_ALL:

            let initialObj = portalShared.cloneObj(state);

            let tempObj = initialObj[action.payload.parentName];

            if (action.payload.parentKey === "") {
                // Category - expand/collapse all categories, if collapse also collapse all groups
                tempObj.expandAll = !tempObj.expandAll;

                for (let i = 0; i < action.payload.templateKeys.length; i++) {
                    // isExpanded = true, then collapse all, if false then expand all
                    tempObj.expander[action.payload.templateKeys[i]].open = !tempObj.expandAll;

                    // If you collapse, then collapse groups also
                    if (tempObj.expandAll) {

                        let categoryExpander = tempObj.expander[action.payload.templateKeys[i]];

                        categoryExpander.groupExpanderObj.expandAll = true; // Since we are closing all groups make sure to flip back to Expand All mode

                        // Collapse so check for groups to collapse
                        if (categoryExpander.hasOwnProperty("groupExpanderObj")) {
                            Object.keys(categoryExpander.groupExpanderObj.expander).forEach(function(key) {
                                categoryExpander.groupExpanderObj.expander[key].open = false;
                            });
                        }
                    }

                }
            } else {
                // Group
                let categoryExpander = tempObj.expander[action.payload.parentKey];

                if (categoryExpander.hasOwnProperty("groupExpanderObj")) {

                    categoryExpander.groupExpanderObj.expandAll = !categoryExpander.groupExpanderObj.expandAll;

                    Object.keys(categoryExpander.groupExpanderObj.expander).forEach(function(key) {
                        categoryExpander.groupExpanderObj.expander[key].open = !categoryExpander.groupExpanderObj.expandAll;
                    });
                }

            }

            return {
                ...initialObj,
            };

        case types.EXPANDER_CLEAR:

            let clonedObj = portalShared.cloneObj(state);
            delete clonedObj[action.payload.parentName];
            return {
                ...clonedObj,
            };

        default:
            return state;
    }
}